/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Title_LeadInputs */

const en_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Latest from`)
};

const es_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo último de`)
};

const de_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neueste von`)
};

const zh_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

const ar_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأحدث من`)
};

const fr_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les dernières nouvelles de`)
};

const vi_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mới nhất từ`)
};

const sw_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habari mpya kutoka kwa`)
};

const th_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ล่าสุดจาก`)
};

const bs_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnovije od`)
};

const ja_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Eglyの`)
};

const ko_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly의`)
};

const pt_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais recente de`)
};

const it_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimi da`)
};

const sv_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senaste från`)
};

const nl_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatste van`)
};

const da_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seneste fra`)
};

const nb_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siste fra`)
};

const fi_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusimmat`)
};

const pl_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najnowsze od`)
};

const ru_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свежие новости от`)
};

const tr_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly'den`)
};

const hi_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly की`)
};

const id_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terbaru dari`)
};

const ms_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terkini daripada`)
};

const cs_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejnovější od`)
};

const el_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τελευταία από`)
};

const he_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`החדשות האחרונות מאת`)
};

const af_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuutste van`)
};

const hu_blog_title_lead = /** @type {(inputs: Blog_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly`)
};

/**
* | output |
* | --- |
* | "Latest from" |
*
* @param {Blog_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const blog_title_lead = /** @type {((inputs?: Blog_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_blog_title_lead(inputs)
	if (locale === "de") return de_blog_title_lead(inputs)
	if (locale === "zh") return zh_blog_title_lead(inputs)
	if (locale === "ar") return ar_blog_title_lead(inputs)
	if (locale === "fr") return fr_blog_title_lead(inputs)
	if (locale === "vi") return vi_blog_title_lead(inputs)
	if (locale === "sw") return sw_blog_title_lead(inputs)
	if (locale === "th") return th_blog_title_lead(inputs)
	if (locale === "bs") return bs_blog_title_lead(inputs)
	if (locale === "ja") return ja_blog_title_lead(inputs)
	if (locale === "ko") return ko_blog_title_lead(inputs)
	if (locale === "pt") return pt_blog_title_lead(inputs)
	if (locale === "it") return it_blog_title_lead(inputs)
	if (locale === "sv") return sv_blog_title_lead(inputs)
	if (locale === "nl") return nl_blog_title_lead(inputs)
	if (locale === "da") return da_blog_title_lead(inputs)
	if (locale === "nb") return nb_blog_title_lead(inputs)
	if (locale === "fi") return fi_blog_title_lead(inputs)
	if (locale === "pl") return pl_blog_title_lead(inputs)
	if (locale === "ru") return ru_blog_title_lead(inputs)
	if (locale === "tr") return tr_blog_title_lead(inputs)
	if (locale === "hi") return hi_blog_title_lead(inputs)
	if (locale === "id") return id_blog_title_lead(inputs)
	if (locale === "ms") return ms_blog_title_lead(inputs)
	if (locale === "cs") return cs_blog_title_lead(inputs)
	if (locale === "el") return el_blog_title_lead(inputs)
	if (locale === "he") return he_blog_title_lead(inputs)
	if (locale === "af") return af_blog_title_lead(inputs)
	if (locale === "hu") return hu_blog_title_lead(inputs)
	return en_blog_title_lead(inputs)
});